import {Component, EventEmitter, Inject, Injector} from "@angular/core";
import {BaseComponentDirective} from "../../../_shared/base/base.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'admin-view-objective-modal',
    templateUrl: './view-objective.dialog.html',
    styleUrls: ['../../../scss/office.scss']
})
export class ViewObjectiveDialog extends BaseComponentDirective{
    public result = new EventEmitter();
    constructor(
        injector: Injector,
        public dialogRef: MatDialogRef<ViewObjectiveDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        super(injector);
    }

    override async ngOnInit() {
        super.ngOnInit();
        console.log(this.data);
    }

    editObjective() {
        this.router.navigate([`/office/new-certification/detail/${this.data.certification.id}/domain/${this.data.certificationDomainId}/objective/${this.data.certificationObjectiveId}/edit`]).then();
        this.close();
    }

    close() {
        this.dialogRef.close();
    }

}
